import LifeCycleEditor from './LifeCycleEditor'

export default LifeCycleEditor
